(() => {
  const selectionStorageKey = 'le-seven-reference-looks-model-session-v3';
  const favouriteStorageKey = 'le-seven-reference-looks-favourites-v3';
  const scenes = ['studio', 'city', 'editorial'];

  const readStorage = (storage, key) => { try { return storage.getItem(key); } catch (error) { return null; } };
  const writeStorage = (storage, key, value) => { try { storage.setItem(key, value); } catch (error) { /* Optional preference enhancement. */ } };
  const titleCase = (value) => value.charAt(0).toUpperCase() + value.slice(1);

  function init(section) {
    const library = window.LeSevenReferenceLooksLibrary;
    const setPdpEntryVisibility = (visible) => {
      document.querySelectorAll('[data-reference-pdp-entry]').forEach((entry) => {
        if (entry.dataset.referenceProductHandle === section.dataset.productHandle) entry.hidden = !visible;
      });
    };
    if (!library?.models?.length || !library?.colourways?.length) {
      setPdpEntryVisibility(false);
      return;
    }
    const element = (selector) => section.querySelector(selector);
    const all = (selector) => Array.from(section.querySelectorAll(selector));
    const validIds = library.models.map((model) => model.id);
    const storedModel = readStorage(sessionStorage, selectionStorageKey);
    let hasExplicitSelection = validIds.includes(storedModel);
    const initialColourway = library.colourways.find((item) => item.product_handle === section.dataset.productHandle) || library.colourways[0];
    const state = {
      modelId: hasExplicitSelection ? storedModel : library.models[0].id,
      scene: 'studio',
      filters: {},
      colourway: initialColourway,
      favourites: (() => { try { const value = JSON.parse(localStorage.getItem(favouriteStorageKey) || '[]'); return Array.isArray(value) ? value.filter((id) => validIds.includes(id)) : []; } catch (error) { return []; } })()
    };
    const data = {
      productTitle: section.dataset.productTitle,
      customerSignedIn: section.dataset.customerSignedIn === 'true',
      filters: [
        { id: 'face_shape', label: 'Face outline', options: ['Oval', 'Round', 'Angular', 'Heart / defined', 'Long'] },
        { id: 'face_width', label: 'Face width', options: ['Narrow', 'Balanced', 'Broad'] },
        { id: 'age_group', label: 'Reference age range', options: ['Adults 18–29', 'Adults 30–44', 'Adults 45–60'] },
        { id: 'gender_expression', label: 'Gender', options: ['Feminine', 'Masculine'] },
        { id: 'skin_tone', label: 'Skin tone', options: ['Light', 'Light-medium', 'Medium', 'Medium-deep', 'Deep'] },
        { id: 'heritage_representation', label: 'Heritage representation', options: ['East Asian', 'South Asian', 'Southeast Asian', 'Black', 'Latinx / Hispanic', 'Middle Eastern / North African', 'White', 'Multiracial'] }
      ]
    };
    const panel = element('[data-reference-panel]');
    const openButton = element('[data-reference-open]');
    const deck = element('[data-reference-scene-deck]');
    let drag = null;
    let suppressSceneClick = false;

    function modelById() { return library.models.find((model) => model.id === state.modelId) || library.models[0]; }
    function hasCompleteDirectSet(model, colourway) {
      return scenes.every((scene) => Boolean(library.directLooks?.[colourway?.id]?.[model.id]?.[scene]));
    }
    function directModelsForColourway(colourway) {
      if (!library.directLooks?.[colourway?.id]) return [];
      return library.models.filter((model) => hasCompleteDirectSet(model, colourway));
    }
    function productColourways() {
      return library.colourways.filter((colourway) => colourway.product_handle === section.dataset.productHandle);
    }
    function directColourwayFor(colourway = state.colourway) {
      if (directModelsForColourway(colourway).length) return colourway;
      return productColourways().find((candidate) => directModelsForColourway(candidate).length) || null;
    }
    const productHasCompleteDirectSet = productColourways()
      .some((colourway) => directModelsForColourway(colourway).length > 0);
    if (!productHasCompleteDirectSet) {
      setPdpEntryVisibility(false);
      return;
    }
    const initialDirectColourway = directColourwayFor(initialColourway);
    const initialReadyModels = directModelsForColourway(initialDirectColourway);
    section.hidden = !initialReadyModels.length;
    setPdpEntryVisibility(Boolean(initialReadyModels.length));
    if (initialReadyModels.length && !hasCompleteDirectSet(modelById(), initialDirectColourway)) {
      state.modelId = initialReadyModels[0].id;
      if (hasExplicitSelection) persistSelection();
    }
    function isFavourite(modelId) { return state.favourites.includes(modelId); }
    function persistSelection() { writeStorage(sessionStorage, selectionStorageKey, state.modelId); }
    function persistFavourites() { writeStorage(localStorage, favouriteStorageKey, JSON.stringify(state.favourites)); }
    function matchingModels() {
      const readyModels = directModelsForColourway(directColourwayFor());
      return readyModels.filter((model) => Object.entries(state.filters).every(([key, value]) => !value || model[key] === value)).sort((a, b) => {
        const favouriteOrder = Number(isFavourite(b.id)) - Number(isFavourite(a.id));
        return favouriteOrder || Number(a.id === state.modelId) - Number(b.id === state.modelId);
      });
    }

    function selectedColourFromPage() {
      const controls = Array.from(document.querySelectorAll('variant-selects input:checked, variant-selects select'));
      const control = controls.find((item) => {
        const optionName = item.dataset.optionName || '';
        const inputName = item.getAttribute('name') || '';
        const visibleLabel = item.closest('fieldset, .product-form__input')?.querySelector('legend, label')?.textContent || '';
        return /colou?r/i.test(`${optionName} ${inputName} ${visibleLabel}`);
      });
      if (!control) return null;
      return control.tagName === 'SELECT' ? control.selectedOptions[0]?.value : control.value;
    }

    function updateColourway({ preserveFallback = true } = {}) {
      const selectedColour = selectedColourFromPage();
      const matching = library.colourways.find((item) => item.product_handle === section.dataset.productHandle && item.color.toLowerCase() === String(selectedColour || '').toLowerCase());
      const productDefault = library.colourways.find((item) => item.product_handle === section.dataset.productHandle);
      state.colourway = matching || productDefault || (preserveFallback ? state.colourway : library.colourways[0]);
      const directColourway = directColourwayFor();
      const readyModels = directModelsForColourway(directColourway);
      const isAvailable = readyModels.length > 0;
      section.hidden = !isAvailable;
      setPdpEntryVisibility(isAvailable);
      if (!isAvailable) return;
      if (!hasCompleteDirectSet(modelById(), directColourway)) {
        state.modelId = readyModels[0].id;
        if (hasExplicitSelection) persistSelection();
      }
      renderModels();
      updateLook();
    }

    function directImageFor(scene, model, colourway) {
      return library.directLooks?.[colourway?.id]?.[model.id]?.[scene] || null;
    }

    function updateSceneDeck({ animate = false } = {}) {
      const activeIndex = scenes.indexOf(state.scene);
      all('[data-reference-scene-card]').forEach((card) => {
        const offset = (scenes.indexOf(card.dataset.referenceScene) - activeIndex + scenes.length) % scenes.length;
        const position = offset === 0 ? 'active' : offset === 1 ? 'next' : 'previous';
        const active = position === 'active';
        card.dataset.stackPosition = position;
        card.setAttribute('aria-current', String(active));
        card.tabIndex = active ? 0 : -1;
        card.setAttribute('aria-label', `${titleCase(card.dataset.referenceScene)} reference look${active ? ', selected' : ''}`);
      });
      element('[data-reference-caption]').textContent = `${titleCase(state.scene)} reference look`;
      if (animate) { deck.classList.remove('is-scene-changing'); window.requestAnimationFrame(() => deck.classList.add('is-scene-changing')); }
    }

    function updatePreferencePrompt() {
      const prompt = element('[data-reference-preference-prompt]');
      const title = element('[data-reference-preference-title]');
      const detail = element('[data-reference-preference-detail]');
      const count = state.favourites.length;
      if (data.customerSignedIn) {
        title.textContent = count ? `${count} saved ${count === 1 ? 'look' : 'looks'}, ready to keep.` : 'Keep the looks you love.';
        detail.textContent = 'This staging demo keeps your selection and saved models on this device. Account preference sync is the next protected-data integration step.';
      } else if (count) {
        title.textContent = `Keep ${count} saved ${count === 1 ? 'look' : 'looks'} beyond this visit.`;
        detail.textContent = 'Your selection stays with this browser for now. Sign in to connect your preferences to a Le Seven account at launch.';
      } else {
        title.textContent = 'Keep the looks you love.';
        detail.textContent = 'Choose favourites to keep them at the front of this selector. Sign in when you are ready to connect preferences to a Le Seven account.';
      }
      prompt.dataset.hasFavourites = String(Boolean(count));
    }

    function updateLook({ animate = false } = {}) {
      const model = modelById();
      const selectedColourway = state.colourway;
      const colourway = directColourwayFor();
      const usesColourwayFallback = colourway?.id !== selectedColourway?.id;
      const intro = element('[data-reference-intro]');
      element('[data-reference-selected-name]').textContent = model.name;
      element('[data-reference-stage-name]').textContent = model.name;
      all('[data-reference-shop-model]').forEach((target) => { target.textContent = model.name; });
      element('[data-reference-product-title]').textContent = colourway?.product_title || data.productTitle;
      if (intro) intro.textContent = `Choose a visual profile to explore styling context for this ${selectedColourway?.color || colourway?.color || 'colourway'} colourway—without uploading a portrait.`;
      let acceptedScenes = 0;
      all('[data-reference-scene-image]').forEach((image) => {
        const scene = image.dataset.referenceSceneImage;
        const directImage = directImageFor(scene, model, colourway);
        const visual = element(`[data-reference-scene-visual="${scene}"]`);
        if (directImage) {
          acceptedScenes += 1;
          image.src = directImage;
          image.alt = `${model.name} wearing ${colourway?.product_title || data.productTitle} in a ${titleCase(scene)} direct photo-realistic reference look`;
          visual?.classList.remove('is-production-pending');
        } else {
          image.removeAttribute('src');
          image.alt = '';
          visual?.classList.add('is-production-pending');
        }
      });
      const note = element('[data-reference-product-note]');
      note.textContent = acceptedScenes === scenes.length && usesColourwayFallback
        ? `Reference imagery for ${colourway?.color} is shown while ${selectedColourway?.color || 'the selected'} colourway is being added. Confirm the exact colour, frame details, measurements and lens options in the product gallery above.`
        : acceptedScenes === scenes.length
          ? `Source-locked photo-realistic reference set for ${colourway?.color || 'this colourway'} — based on the official front and angled product sources. Confirm the exact colour, frame details, measurements and lens options in the product gallery above.`
          : `Reference images are not available for this product with ${model.name} yet. Confirm the exact colour, frame details, measurements and lens options in the product gallery above.`;
      const favouriteButton = element('[data-reference-favorite-selected]');
      const favourited = isFavourite(model.id);
      if (favouriteButton) {
        favouriteButton.setAttribute('aria-pressed', String(favourited));
        favouriteButton.classList.toggle('is-favourited', favourited);
        favouriteButton.querySelector('[aria-hidden="true"]').textContent = favourited ? '♥' : '♡';
        element('[data-reference-favorite-selected-label]').textContent = favourited ? `Saved ${model.name}` : `Save ${model.name}`;
      }
      const summary = element('[data-reference-favorite-summary]');
      if (summary) {
        summary.hidden = state.favourites.length === 0;
        summary.textContent = `${state.favourites.length} saved ${state.favourites.length === 1 ? 'model' : 'models'}`;
      }
      updateSceneDeck({ animate });
      updatePreferencePrompt();
    }

    function renderModels() {
      const models = matchingModels();
      const grid = element('[data-reference-model-grid]');
      const empty = element('[data-reference-empty]');
      element('[data-reference-result-count]').textContent = `${models.length} ${models.length === 1 ? 'reference' : 'references'} available${state.favourites.length ? ' · saved models first' : ''}`;
      grid.innerHTML = '';
      grid.hidden = models.length === 0;
      empty.hidden = models.length !== 0;
      models.forEach((model) => {
        const selected = model.id === state.modelId;
        const favourite = isFavourite(model.id);
        const card = document.createElement('article');
        card.className = `le-seven-reference-looks__model${selected ? ' is-selected' : ''}${favourite ? ' is-favourite' : ''}`;
        card.innerHTML = `<button type="button" class="le-seven-reference-looks__model-select" data-reference-model-select="${model.id}" aria-pressed="${selected}"><img src="${model.portrait}" alt="${model.name}, reference identity" loading="lazy"><span class="le-seven-reference-looks__model-info"><strong>${model.name}</strong><small>${model.face_shape} · ${model.face_width}</small></span></button><button type="button" class="le-seven-reference-looks__model-favorite" data-reference-model-favorite="${model.id}" aria-label="${favourite ? 'Remove' : 'Save'} ${model.name} as a favourite" aria-pressed="${favourite}"><span aria-hidden="true">${favourite ? '♥' : '♡'}</span></button>${favourite ? '<span class="le-seven-reference-looks__saved-badge">Saved</span>' : ''}`;
        card.querySelector('[data-reference-model-select]').addEventListener('click', () => selectModel(model.id));
        card.querySelector('[data-reference-model-favorite]').addEventListener('click', () => toggleFavourite(model.id));
        grid.append(card);
      });
    }

    function renderFilters() {
      const filters = element('[data-reference-filters]');
      filters.innerHTML = '';
      data.filters.forEach((filter) => {
        const wrap = document.createElement('label');
        wrap.className = 'le-seven-reference-looks__filter';
        wrap.innerHTML = `<span>${filter.label}</span><select aria-label="${filter.label}"><option value="">Any</option>${filter.options.map((option) => `<option value="${option}">${option}</option>`).join('')}</select>`;
        const select = wrap.querySelector('select');
        select.value = state.filters[filter.id] || '';
        select.addEventListener('change', () => { state.filters[filter.id] = select.value; renderModels(); });
        filters.append(wrap);
      });
    }

    const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;
    function setPanel(open) {
      if (!isMobileViewport()) { section.classList.toggle('is-selector-expanded', open); openButton.setAttribute('aria-expanded', String(open)); if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      section.classList.toggle('is-selector-open', open); openButton.setAttribute('aria-expanded', String(open)); if (open) panel.querySelector('select, button')?.focus(); else openButton.focus({ preventScroll: true });
    }
    function closePanel() { setPanel(false); }
    function selectModel(modelId) { state.modelId = modelId; hasExplicitSelection = true; persistSelection(); updateLook({ animate: true }); renderModels(); closePanel(); }
    function toggleFavourite(modelId) { state.favourites = isFavourite(modelId) ? state.favourites.filter((id) => id !== modelId) : [...state.favourites, modelId]; persistFavourites(); updateLook(); renderModels(); }
    function reset() { state.filters = {}; renderFilters(); renderModels(); }
    function setScene(scene, options = {}) { if (!scenes.includes(scene) || scene === state.scene) return; state.scene = scene; updateSceneDeck({ animate: options.animate !== false }); }
    function moveScene(direction) { const index = scenes.indexOf(state.scene); setScene(scenes[(index + direction + scenes.length) % scenes.length]); }
    function clearDrag() { deck.style.removeProperty('--rl-scene-drag'); deck.classList.remove('is-dragging'); drag = null; }
    function handlePointerDown(event) { if (event.pointerType === 'mouse' && event.button !== 0) return; drag = { pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, axis: null, moved: false }; deck.setPointerCapture?.(event.pointerId); }
    function handlePointerMove(event) { if (!drag || event.pointerId !== drag.pointerId) return; const deltaX = event.clientX - drag.startX; const deltaY = event.clientY - drag.startY; const distanceX = Math.abs(deltaX); const distanceY = Math.abs(deltaY); if (!drag.axis && (distanceX > 5 || distanceY > 5)) drag.axis = distanceX >= distanceY * .65 ? 'horizontal' : 'vertical'; if (drag.axis !== 'horizontal') return; event.preventDefault(); drag.moved = true; deck.classList.add('is-dragging'); deck.style.setProperty('--rl-scene-drag', `${Math.max(-64, Math.min(64, deltaX))}px`); }
    function handlePointerEnd(event) { if (!drag || event.pointerId !== drag.pointerId) return; const deltaX = event.clientX - drag.startX; const moved = drag.moved; if (deck.hasPointerCapture?.(event.pointerId)) deck.releasePointerCapture(event.pointerId); clearDrag(); if (moved) { suppressSceneClick = true; window.setTimeout(() => { suppressSceneClick = false; }, 0); if (Math.abs(deltaX) > 32) moveScene(deltaX < 0 ? 1 : -1); } }
    function handlePointerCancel(event) { if (!drag || event.pointerId !== drag.pointerId) return; if (deck.hasPointerCapture?.(event.pointerId)) deck.releasePointerCapture(event.pointerId); clearDrag(); }

    openButton.addEventListener('click', () => setPanel(!(isMobileViewport() ? section.classList.contains('is-selector-open') : section.classList.contains('is-selector-expanded'))));
    all('[data-reference-close]').forEach((button) => button.addEventListener('click', closePanel));
    all('[data-reference-reset]').forEach((button) => button.addEventListener('click', reset));
    element('[data-reference-favorite-selected]')?.addEventListener('click', () => toggleFavourite(state.modelId));
    all('[data-reference-previous]').forEach((button) => button.addEventListener('click', () => moveScene(-1)));
    all('[data-reference-next]').forEach((button) => button.addEventListener('click', () => moveScene(1)));
    deck.addEventListener('click', (event) => { const card = event.target.closest('[data-reference-scene-card]'); if (!card) return; if (suppressSceneClick) { event.preventDefault(); return; } setScene(card.dataset.referenceScene); });
    deck.addEventListener('pointerdown', handlePointerDown); deck.addEventListener('pointermove', handlePointerMove, { passive: false }); deck.addEventListener('pointerup', handlePointerEnd); deck.addEventListener('pointercancel', handlePointerCancel);
    deck.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') { event.preventDefault(); moveScene(-1); } if (event.key === 'ArrowRight') { event.preventDefault(); moveScene(1); } });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && section.classList.contains('is-selector-open')) closePanel(); });
    const scheduleColourwayUpdate = () => window.setTimeout(updateColourway, 40);
    document.addEventListener('change', (event) => { if (event.target.closest('variant-selects')) scheduleColourwayUpdate(); });
    document.addEventListener('input', (event) => { if (event.target.closest('variant-selects')) scheduleColourwayUpdate(); });
    document.addEventListener('click', (event) => { if (event.target.closest('variant-selects')) scheduleColourwayUpdate(); });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, scheduleColourwayUpdate);
    window.addEventListener('resize', () => { if (!isMobileViewport()) { section.classList.remove('is-selector-open'); openButton.setAttribute('aria-expanded', 'false'); } });

    renderFilters(); renderModels(); if (initialReadyModels.length) updateLook();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-reference-looks-section]').forEach(init);
    document.querySelectorAll('[data-reference-entry]').forEach((entry) => entry.addEventListener('click', (event) => {
      const target = document.getElementById('reference-looks'); const trigger = target?.querySelector('[data-reference-open]'); if (!target || !trigger) return; event.preventDefault();
      if (window.matchMedia('(max-width: 749px)').matches) { trigger.click(); return; }
      if (!target.classList.contains('is-selector-expanded')) trigger.click(); window.requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }));
  });
})();
